<template>
  <div class="smallResendEmail"
    style="height:100%;width: 100%;display: flex;align-items: center;justify-content: center;padding-bottom: 5rem; margin-top: 2rem;">
    <div style="width:80%;" class="resend-container">
      <div style="display: flex;flex-direction: column;">
        <div style="justify-content: center; display: flex;">
          <span class="errorText" style="color:#300003;font-size:14px"> Didn't Receive? &nbsp; </span> <span
            @click="handleResend()" class="errorText"
            :style="isResendLoading ? 'pointer-events: none;color:gray' : 'pointer-events: auto;'"
            style="color:#F20E17;text-decoration:underline;cursor: pointer;font-size:14px">Resend Email</span>
        </div>
        <div class="formSevenDayTrial"
          style="border:1px solid #F20E17;font-size: 18px;color:#F20E17;width: fit-content;border-radius: 5px;padding: 5px 15px 5px 15px;font-weight: 500;display: none;margin: 20px 0px 20px 0px;">
          {{trial_days}}-DAYS FREE TRIAL
        </div>
        <div class="mediumText" v-if="isResponseMessage" style="font-size: 16px;margin-top: 2px;color: #300003;">{{
          isResponseMessage }}</div>
      </div>
      <div style="margin:1% 0 1% 0">
        <h1 class="mobileLargeText" style="color:#300003;font-size: 25px;font-weight: bold; margin-bottom: 2%; text-align: center;">Welcome to ProTrader,
          Please <span style="color:#F20E17">verify</span> your email</h1>
          <h4 style="text-align: center;font-size:16px;font-weight: normal;">We’ve sent you an email with a verification link, please check your inbox.</h4>
      </div>
      <div class="sso-divider">
        <span>or</span>
      </div>
      <div class="p-field p-d-flex p-jc-center">
         <div>
    <!-- easily customize the text using the 'label' prop -->
    <GoogleSsoBtn label="Continue with Google" @click="loginWithGoogle" />
  </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../config';
import GoogleSsoBtn from './googleSsoBtn.vue'

export default {
  name: 'ResendEmail',
  components:{
   GoogleSsoBtn
  },
  props: {
    isResendLoading: {
      type: {
        type: Boolean,
        default: false
      },
    },
    isResponseMessage: {
      type: {
        type: String,
        default: ""
      },
    }
  },
  data() {
    return {
      trial_days: config.TRIAL_DAYS
    };
  },
  methods: {
    handleResend() {
      this.$emit('resendEmail');
    },
        loginWithGoogle(){
      const base = config.USER_API
      window.location.href = `${base}auth/google`

      
      let {currency,product} = this.$route.query;
              if (currency && product) {
              sessionStorage.setItem('pending_registration', JSON.stringify({ currency, product }));
            }

             const params = new URLSearchParams();
            if (currency) params.append('currency', currency);
            if (product) params.append('product', product);

              if (params.toString()) {
                 url += `?${params.toString()}`;
            }
            window.location.href=url;
    }

  }
};
</script>

<style scoped>
.sso-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13px;
  
  /* Increased top and bottom margin for more spacing */
  /* Format is: top right bottom left */
  margin: 2rem auto 2.5rem auto; 
  
  /* Reduced from 300px to 150px to make it exactly half the width */
  max-width: 550px;    
}
</style>